import { useBreakpointValue } from '@genial/utils';
import { useNavigation } from '@react-navigation/native';
import { useCallback } from 'react';

import { FilterModal } from '../../../components/FilterModal';
import { SignedInNavigationScreenNavigationProp } from '../../../routes/types';
import { dividendHistoryFilterAtom } from '../../../store/dividendHistory/atom';

export const DividendHistoryFilterModal = () => {
  const navigation = useNavigation<SignedInNavigationScreenNavigationProp>();
  const isMobile = useBreakpointValue({ base: true, sm: false });
  const isTablet = useBreakpointValue({ base: false, sm: true, lg: false });

  const goBack = useCallback(() => {
    if (navigation.canGoBack()) {
      navigation.goBack();
    }
  }, [navigation]);

  const getSliderModalWidth = useCallback(() => {
    if (isMobile) {
      return 1;
    }

    if (isTablet) {
      return 0.5;
    }

    return 0.3;
  }, [isMobile, isTablet]);

  return (
    <FilterModal
      onClose={goBack}
      sliderModalWidth={getSliderModalWidth()}
      filterAtom={dividendHistoryFilterAtom}
    />
  );
};
